// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperClaiming-cls1_tMO","cls2":"PaperClaiming-cls2_Fkj PaperClaiming-cls1_tMO"};